export const SET_PROMO_ERROR = 'SET_PROMO_ERROR';

export const setPromoError = (payload) => {
  return {
    type: SET_PROMO_ERROR,
    payload,
  };
};
